import { render, staticRenderFns } from "./cardDynamics.vue?vue&type=template&id=017bf8d3&scoped=true"
import script from "./cardDynamics.vue?vue&type=script&lang=js"
export * from "./cardDynamics.vue?vue&type=script&lang=js"
import style0 from "./cardDynamics.vue?vue&type=style&index=0&id=017bf8d3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017bf8d3",
  null
  
)

export default component.exports